import { Box, styled, Typography } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import { Colors, ColorsV2 } from 'app/constants/color';

const ParentDiv = styled(Box)({
  width: '100%',
  marginTop: '8%',
  marginLeft: '10px',
});

const FilterDiv = styled(Box)({
  borderRadius: '5px',
  height: '2.3em',
  fontSize: '0.7em',
  fontWeight: 'light',
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingInline: '5px',
});

const TitleContainer = styled(Box)({
  margin: '0.8em',
  width: '95%',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  borderBottom: `1px solid ${ColorsV2.white}`,
});

const Title = styled(Typography)({
  fontFamily: 'DM Sans, sans-serif',
  fontWeight: 700,
  fontSize: '1em',
  color: ColorsV2.white,
  textTransform: 'uppercase',
});

const TableHeader = styled(Box)({
  marginTop: '3em',
  backgroundColor: 'transparent',
  border: `1px solid ${Colors.outline}`,
  width: '95%',
  alignItems: 'center',
  borderRadius: '8px',
  marginLeft: '1em',
  marginBottom: '1em',
});

const DarkmodeTableHeader = styled(Box)({
  marginTop: '3em',
  backgroundColor: 'transparent',
  border: `1px solid ${ColorsV2.acent}`,
  width: '95%',
  alignItems: 'center',
  borderRadius: '8px',
  padding: '2em',
  marginLeft: '1em',
  marginBottom: '1em',
});

const CustomDiv = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  margin: '0.7em',
  padding: '0.5em',
  borderRadius: '8px',
  alignItems: 'center',
  justifyContent: 'space-between',
});

const TableDiv = styled(Box)({
  display: 'flex',
  height: '100%',
  marginBottom: '2rem',
});

const CustomHeaderDiv1 = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: '40%',
});

const CustomHeaderDiv2 = styled(Box)({
  display: 'flex',
  flexDirection: 'row-reverse',
  alignItems: 'center',
  width: 500,
  justifyContent: 'space-around',
});

const MyTablePagination = styled(TablePagination)({
  font: 'DM Sans',
  fontSize: '30px',
});

const scrollbarStyle = {
  /* Set the width and height of the scrollbar */
  scrollbarWidth: 'thin',
  scrollbarHeight: 'thin',

  /* Track */
  scrollbarTrackColor: '#f1f1f1',

  /* Handle */
  scrollbarThumbColor: '#888',
  scrollbarThumbRadius: '5px',

  /* Handle on hover */
  scrollbarThumbHoverColor: '#555',
};
export {
  ParentDiv,
  TableHeader,
  CustomDiv,
  TableDiv,
  CustomHeaderDiv1,
  CustomHeaderDiv2,
  TitleContainer,
  Title,
  DarkmodeTableHeader,
  MyTablePagination,
  scrollbarStyle,
  FilterDiv,
};
